<template>
  <div class="c">
    <div class="c-left">
      <InformationStatistics />
      <SubjectCount :user="count" />
      <GradeCount :userTypeList="userTypeList" :userTypeCount="userTypeCount" />
    </div>
    <div class="c-center">
      <map-shushan />
    </div>
    <div class="c-right">
      <school-top />
      <accurate-study title="智适应学习" />
      <adapt-study />
    </div>
  </div>
</template>

<script>
import SchoolTop from './school-type.vue';
import AccurateStudy from './accurate-study.vue';
import AdaptStudy from './adapt-study.vue';
import InformationStatistics from './information-statistics.vue';
import SubjectCount from './subject-count.vue';
import GradeCount from './grade-count.vue';
import MapShushan from './map-shushan.vue';

export default {
  name: 'InformationEducation',
  components: {
    SchoolTop,
    AccurateStudy,
    AdaptStudy,
    InformationStatistics,
    SubjectCount,
    GradeCount,
    MapShushan,
  },
  data() {
    return {
      count: [274, 485, 306, 133, 110],
      userTypeList: ['三年级', '四年级', '五年级', '六年级', '七年级', '八年级', '九年级'],
      userTypeCount: [
        { value: 7274, name: '三年级' },
        { value: 9479, name: '四年级' },
        { value: 13986, name: '五年级' },
        { value: 17894, name: '六年级' },
        { value: 14690, name: '七年级' },
        { value: 12784, name: '八年级' },
        { value: 9685, name: '九年级' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.c {
  width: 100%;
  height: 100%;
  display: flex;
  &-left {
    width: 402px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &-center {
    flex: 1;
  }
  &-right {
    width: 402px;
    display: flex;
    flex-direction: column;
  }
}
</style>
